import styled from 'styled-components';
import { XIColors } from '@inmoment/the-kitchen';
const { orca } = XIColors;

interface PlaygroundWrapperProps {
  isSun: boolean;
  isPlayground?: boolean;
}
export const PlaygroundWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  min-height: 613px;
  width: 100%;
  background: ${(props: PlaygroundWrapperProps) => (props.isSun ? orca.primary : 'white')};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  display: flex;
`;

interface AppLauncherWrapperProps {
  visible: boolean;
}
export const AppLauncherWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: ${(props: AppLauncherWrapperProps) => (props.visible ? 400 : 0)}px;
  z-index: 99999;
  transition: right 0.5s ease-in-out;
  @media (max-width: 500px) {
    width: 100%;
    right: ${(props: AppLauncherWrapperProps) => (props.visible ? 0 : -600)}px;
    transition: none;
  }
`;
